var Vendd = (function (Vendd) {
    'use strict';

    Vendd.StockTrackerSystem = (function (StockTrackerSystem) {

        StockTrackerSystem.Messages = (function (Messages) {

            Messages.GetModel = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetModel', null);
            };
            Messages.GetModel.className = 'Vendd.StockTrackerSystem.Messages.GetModel';

            Messages.GetModelFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.StockTrackerSystem.Messages.GetModelFailed';

            Messages.GetModelSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.StockTrackerSystem.Messages.GetModelSuccess';



            Messages.Remove = function (VinNumber) {
                var data = {
                    VinNumber: VinNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.Remove', data);
            };
            Messages.Remove.className = 'Vendd.StockTrackerSystem.Messages.Remove';

            Messages.RemoveSuccess = function (VinNumber) {
                var data = {
                    VinNumber: VinNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.RemoveSuccess', VinNumber);
            };
            Messages.RemoveSuccess.className = 'Vendd.StockTrackerSystem.Messages.RemoveSuccess';

            Messages.RemoveFailed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.RemoveFailed', data);
            };
            Messages.RemoveFailed.className = 'Vendd.StockTrackerSystem.Messages.RemoveFailed';



            Messages.ConfirmInventory = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ConfirmInventory');
            };
            Messages.ConfirmInventory.className = 'Vendd.StockTrackerSystem.Messages.ConfirmInventory';

            Messages.ConfirmInventorySuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ConfirmInventorySuccess');
            };
            Messages.ConfirmInventorySuccess.className = 'Vendd.StockTrackerSystem.Messages.ConfirmInventorySuccess';

            Messages.ConfirmInventoryFailed = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ConfirmInventoryFailed');
            };
            Messages.ConfirmInventoryFailed.className = 'Vendd.StockTrackerSystem.Messages.ConfirmInventoryFailed';

            Messages.UndoConfirmInventory = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventory');
            };
            Messages.UndoConfirmInventory.className = 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventory';

            Messages.UndoConfirmInventorySuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventorySuccess');
            };
            Messages.UndoConfirmInventorySuccess.className = 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventorySuccess';

            Messages.UndoConfirmInventoryFailed = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventoryFailed');
            };
            Messages.UndoConfirmInventoryFailed.className = 'Vendd.StockTrackerSystem.Messages.UndoConfirmInventoryFailed';



            Messages.GetSubPartners = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetSubPartners', null);
            };
            Messages.GetSubPartners.className = 'Vendd.StockTrackerSystem.Messages.GetSubPartners';

            Messages.GetSubPartnersSuccess = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetSubPartnersSuccess', data);
            };
            Messages.GetSubPartnersSuccess.className = 'Vendd.StockTrackerSystem.Messages.GetSubPartnersSuccess';

            Messages.GetSubPartnersFailed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.GetSubPartnersFailed', data);
            };
            Messages.GetSubPartnersFailed.className = 'Vendd.StockTrackerSystem.Messages.GetSubPartnersFailed';



            Messages.ChangePartner = function (vinNumber, partnerItemId) {
                var data = {
                    ProductIdentifier: vinNumber,
                    PartnerItemId: partnerItemId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ChangePartner', data);
            };
            Messages.ChangePartner.className = 'Vendd.StockTrackerSystem.Messages.ChangePartner';

            Messages.ChangePartnerSuccess = function (VinNumber) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ChangePartnerSuccess', VinNumber);
            };
            Messages.ChangePartnerSuccess.className = 'Vendd.StockTrackerSystem.Messages.ChangePartnerSuccess';

            Messages.ChangePartnerFailed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.StockTrackerSystem.Messages.ChangePartnerFailed', data);
            };
            Messages.ChangePartnerFailed.className = 'Vendd.StockTrackerSystem.Messages.ChangePartnerFailed';

            
            return Messages;

        })(StockTrackerSystem.Messages || {});

        return StockTrackerSystem;

    })(Vendd.StockTrackerSystem || {});

    return Vendd;

})(Vendd || {});